import BnetLogoWhite from 'public/images/bnet-logo-white.svg?react'
import BnetLogoBlack from 'public/images/bnet-logo.svg?react'
import { useTheme } from '@/components/theme-provider'

export const useLogo = () => {
  const { currentScheme } = useTheme()
  const Logo = currentScheme === 'dark' ? BnetLogoWhite : BnetLogoBlack

  return { Logo }
}
